import React,{useEffect, useState} from 'react'
import Icon from '@mdi/react';
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import { useTranslation } from 'react-i18next';
import {ReactComponent as IconCloseBlack } from '../../../../assets/icons/ic-close-black.svg';

// 비밀번호 패스워드 변경 Confirm Modal Component
const ResetPwd = ({ isOpen, type, title,message, onOk, onCancel }) => {
    const { t } = useTranslation()
    const [pass, setPass] = useState('');
    const [pass2, setPass2] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [chkError, setChkError] = useState(false);
    const [passValid, setPassValid] = useState({
        lowerCase: false,
        number: false,
        specialChar: false,
        length: false,
        match: false
    });
    const isAllValid = Object.values(passValid).every(Boolean);
    const [isSecure, setIsSecure] = useState({        
        pass : true,
        pass2 : true
    })

    useEffect(() => {
        setPassValid({            
            lowerCase: /[a-z]/.test(pass),
            number: /[0-9]/.test(pass),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(pass),
            length: pass.length >= 8 && pass.length <= 16,
            match: pass !== '' && pass === pass2
        });
    }, [pass, pass2]);

    useEffect(() => {
                
        if(!passValid.lowerCase || !passValid.number || !passValid.specialChar || !passValid.length || !passValid.match) {
            if(!pass && !pass2){
                setChkError(false);
                return;
            }
            setChkError(true);
            
            // 우선순위에 따라 첫 번째 에러만 표시
            if(!passValid.lowerCase){
                setErrorMsg(t('admin.Account.confirm.resetPwdErrorLowerCase'));
            } else if(!passValid.number){
                setErrorMsg(t('admin.Account.confirm.resetPwdErrorNumber'));
            } else if(!passValid.specialChar){
                setErrorMsg(t('admin.Account.confirm.resetPwdErrorSpecialChar'));
            } else if(!passValid.length){
                setErrorMsg(t('admin.Account.confirm.resetPwdErrorLength'));
            } else if(!passValid.match){
                setErrorMsg(t('admin.Account.confirm.resetPwdErrorMatch'));
            }
        } else {
            setChkError(false);
            setErrorMsg('');
        }
    }, [passValid]);

    return (
        isOpen &&
        <div className="absolute w-full h-full content-center whitespace-pre-line" style={{ top: 0, left: 0, background: 'rgba(0,0,0,0.3)' }}>
            <div className={`mx-auto w-[360px] ${type == 'resetPwd' ? 'h-[180px]' : 'h-[240px]'} bg-[#DEDEDE] text-center flex flex-col rounded-[8px]`}>
                <div className="flex h-[38px] bg-[#CECECE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">
                    <div className="">{title || 'MODAL'}</div>
                    <IconCloseBlack className="ml-auto cursor-pointer" onClick={() => { onCancel() }}/>
                </div>        

                {
                    type == 'resetPwd' && (
                        <div className="flex-1 flex items-center justify-center bg-[#DEDEDE]">{message || 'MODAL Message'}</div>
                    )
                }

                {
                    type == 'resetPwd2' && (
                        <>
                            <div className="flex-1 flex flex-col items-start justify-start bg-[#DEDEDE] px-[20px] mt-[20px]">
                                <p className="text-[#000] font-pretendard text-[14px] font-light leading-[110%] mb-[6px]">{t(`admin.Account.confirm.resetPwdTitle`)}</p>
                                <div className='relative w-full'>
                                    <input className={`admin-input-confirm w-full ${chkError ? 'error' : ''}`} 
                                        type={`${isSecure.pass ? "password" : "text"}`}
                                        value={pass} 
                                        onChange={(e) => {setPass(e.target.value);}} 
                                        placeholder={t(`admin.Account.confirm.resetPwdPlaceholder`)}
                                    />
                                    <button type="button" onClick={() => setIsSecure({...isSecure, pass: !isSecure.pass})} className="absolute right-2 top-2">
                                        <Icon path={isSecure.pass ? mdiEyeOffOutline : mdiEyeOutline} size={1} color="#1111117D" />
                                    </button>
                                </div>                                                              
                            </div>
                            <div className="flex-1 flex flex-col items-start justify-start bg-[#DEDEDE] px-[20px] mt-[10px] mb-[20px]">
                                <p className="text-[#000] font-pretendard text-[14px] font-light leading-[110%] mb-[6px]">{t(`admin.Account.confirm.resetPwdConfirmTitle`)}</p>
                                <div className='relative w-full'>
                                    <input className={`admin-input-confirm w-full ${chkError ? 'error' : ''}`}
                                        type={`${isSecure.pass2 ? "password" : "text"}`}
                                        value={pass2} 
                                        onChange={(e) => {setPass2(e.target.value);}} 
                                        placeholder={t(`admin.Account.confirm.resetPwdConfirmPlaceholder`)}
                                    />
                                    <button type="button" onClick={() => setIsSecure({...isSecure, pass2: !isSecure.pass2})} className="absolute right-2 top-2">
                                        <Icon path={isSecure.pass2 ? mdiEyeOffOutline : mdiEyeOutline} size={1} color="#1111117D" />
                                    </button>
                                </div>
                                
                                {chkError && <p className='mt-[4px] text-[#C50024] font-pretendard text-[12px] font-normal leading-[16px]'>{errorMsg}</p>}
                            </div>
                        </>
                    )
                }

                <div className="flex items-center justify-end bg-[#DEDEDE] px-[20px] py-[12px] rounded-bl-[8px] rounded-br-[8px]">
                    <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] mr-[8px]  gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] cursor-pointer text-[#000] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { onCancel() }}>{t('resetPassword.cancel')}</div>
                    <div className={`${type == 'resetPwd' ? '' : (isAllValid ? '' : 'opacity-30')} flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] cursor-pointer text-[#FFF] text-center font-pretendard text-[16px] font-light leading-[110%]`} onClick={type == 'resetPwd' ? () => onOk() : (isAllValid ? () => onOk(pass) : undefined)} >{t('resetPassword.ok')}</div>
                </div>              
            </div>
        </div>
    )
}

export default ResetPwd